import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { inject, Type } from '@angular/core';

import { LoginService } from '../services/login-service/login.service';
import { ROUTER_CONSTANTS } from '../constants/router.constants';

/**
 * Builds a CanMatchFn that sends logged-in users to the dashboard, and
 * users without the required stored data (e.g. route opened directly
 * without authenticating first) to login.
 * @param dataServiceToken DI token for the service holding the stored data
 * @param hasData predicate checking whether the required data is present
 * @returns boolean or UrlTree redirect
 */
export function createDataAccessGuard<T>(
  dataServiceToken: Type<T>,
  hasData: (dataService: T) => boolean,
): CanMatchFn {
  return (): boolean | UrlTree => {
    const loginService = inject(LoginService);
    const dataService = inject(dataServiceToken);
    const router = inject(Router);

    if (loginService.isLoggedIn) {
      return router.createUrlTree([ROUTER_CONSTANTS.dashboard]);
    }

    if (!hasData(dataService)) {
      return router.createUrlTree([ROUTER_CONSTANTS.login]);
    }

    return true;
  };
}
